var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessLeafLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 82,
    viewBox: "0 0 58 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.4976 70.1941C44.5874 69.7377 43.4793 70.0698 42.9702 70.9515V70.9515C42.4611 71.8333 42.7276 72.959 43.5779 73.519L52.6859 79.517C53.9182 80.3285 55.5795 79.9353 56.3172 78.6574V78.6574C57.055 77.3796 56.5649 75.7443 55.2459 75.0829L45.4976 70.1941Z",
    fill: "url(#paint0_linear_17232_1051)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8706 29.3119C27.008 26.4455 30.4824 20.9563 30.4824 14.6555C30.4824 8.35538 27.0086 2.86657 21.872 -7.52751e-07C16.7345 2.86636 13.2601 8.35559 13.2601 14.6563C13.2601 20.9565 16.7339 26.4453 21.8706 29.3119Z",
    fill: "url(#paint1_linear_17232_1051)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9702 45.4618C21.5983 45.4905 22.1845 45.152 22.4737 44.5937C25.0169 39.6844 25.0813 33.6219 22.1117 28.4785C19.1422 23.335 13.8596 20.3596 8.3365 20.1073C7.70839 20.0786 7.12218 20.4171 6.83297 20.9754C4.28985 25.8847 4.22542 31.9472 7.19499 37.0906C10.1646 42.2341 15.4471 45.2096 20.9702 45.4618Z",
    fill: "url(#paint2_linear_17232_1051)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5053 60.2492C31.0636 59.96 31.402 59.3739 31.3734 58.7458C31.1215 53.2223 28.146 47.9393 23.0022 44.9695C17.8589 42 11.7966 42.0644 6.88734 44.6073C6.32905 44.8965 5.99058 45.4827 6.01923 46.1107C6.27114 51.6342 9.24667 56.9172 14.3904 59.887C19.5337 62.8565 25.5961 62.7921 30.5053 60.2492Z",
    fill: "url(#paint3_linear_17232_1051)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9276 68.1063C47.2665 67.5768 47.2665 66.8999 46.9277 66.3703C43.9478 61.7126 38.7293 58.625 32.7897 58.625C26.8507 58.625 21.6327 61.712 18.6526 66.3689C18.3137 66.8985 18.3137 67.5753 18.6525 68.1049C21.6324 72.7626 26.8509 75.8502 32.7905 75.8502C38.7296 75.8502 43.9476 72.7633 46.9276 68.1063Z",
    fill: "url(#paint4_linear_17232_1051)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17232_1051",
    x1: 64.0233,
    y1: 82.6481,
    x2: 28.2136,
    y2: 62.7035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#986D16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331731,
    stopColor: "#C5992B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#E5C74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17232_1051",
    x1: 21.418,
    y1: 26.8942,
    x2: 21.418,
    y2: 2.41772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#986D16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331731,
    stopColor: "#C5992B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#E5C74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17232_1051",
    x1: 11.2664,
    y1: 40.1875,
    x2: 17.8944,
    y2: 25.2646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#986D16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331731,
    stopColor: "#C5992B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#E5C74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17232_1051",
    x1: 15.2997,
    y1: 58.0403,
    x2: 20.7144,
    y2: 45.7939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#986D16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331731,
    stopColor: "#C5992B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#E5C74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_17232_1051",
    x1: 32.9388,
    y1: 74.4903,
    x2: 32.9388,
    y2: 60.8915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#986D16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331731,
    stopColor: "#C5992B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#E5C74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDCA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessLeafLeft);
export default __webpack_public_path__ + "static/media/success-leaf-left.2674ec859dab381f7cdd1928a50a39e5.svg";
export { ForwardRef as ReactComponent };